function getBestNonNegativeLoanLimit(limits, loanPurpose) {
  let maxLimit = 0;
  let bankLoan = null;

  for (const [key, limit] of Object.entries(limits || {})) {
    if (key === "max_pozicka_podla_ltv") continue;

    const loanObject = limit?.[loanPurpose];
    const value = Number(loanObject?.value);
    if (
      loanObject &&
      loanObject.success &&
      Number.isFinite(value) &&
      value >= 0 &&
      (bankLoan === null || maxLimit < value)
    ) {
      maxLimit = value;
      bankLoan = key;
    }
  }

  return {maxLimit, bankLoan};
}

module.exports = {getBestNonNegativeLoanLimit};
